import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "phone-number-selector-container" }
const _hoisted_2 = { class: "label" }
const _hoisted_3 = { class: "phone-number-selector-wrapper" }
const _hoisted_4 = { class: "country-code" }
const _hoisted_5 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_country_selector = _resolveComponent("country-selector")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t('enterPhoneNumber')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_country_selector, {
        showCountryName: false,
        selectedCountry: _ctx.selectedCountry,
        "onUpdate:selectedCountry": _ctx.onSelectedCountry
      }, null, 8, ["selectedCountry", "onUpdate:selectedCountry"]),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "divider" }, null, -1)),
      _createElementVNode("p", _hoisted_4, "+" + _toDisplayString((_ctx.selectedCountry as NamedCountry)?.prefix), 1),
      _createElementVNode("input", {
        value: _ctx.phoneNumber,
        class: "phone-number-input blank-styling",
        autofocus: "",
        onInput: _cache[0] || (_cache[0] = (event) => _ctx.onPhonenumberChanged((event.target as HTMLInputElement).value))
      }, null, 40, _hoisted_5)
    ])
  ]))
}